import {
  CsvExport,
  ExcelExport,
  ExcelSheet,
} from '../models/api/core/export/export';

export class CustomFieldExportMapper {
  static toCsvExport(rows: any[], columns: any[], fileName: string): CsvExport {
    const headers = columns.map(this.getLabel);
    const dataRows = rows.map((row) =>
      columns.map((col) => this.getColumnValue(row, col.name)),
    );

    return {
      fileName,
      headers,
      rows: dataRows,
    };
  }

  static toExcelExport(
    rows: any[],
    columns: any[],
    fileName: string,
    sheetLabel: string,
  ): ExcelExport {
    const headers = columns.map(this.getLabel);
    const dataRows = rows.map((row) =>
      columns.map((col) => this.getColumnValue(row, col.name)),
    );

    const sheet: ExcelSheet = {
      label: sheetLabel,
      headers,
      rows: dataRows,
    };

    return {
      fileName,
      sheets: [sheet],
    };
  }

  private static getLabel(column: any): string {
    const headerMappings: Record<string, string> = {
      tabName: 'Tab Name',
      fieldNumber: 'Field #',
      longLabel: 'Field',
      value: 'Value',
      validationDesc: 'Validation Code Description',
    };

    return headerMappings[column.name] || column.label || column.name;
  }

  private static getColumnValue(row: any, name: string): any {
    if (!row || !name) return undefined;

    const keys = Object.keys(row);
    const lowerKeyMap = keys.reduce(
      (acc, key) => {
        acc[key.toLowerCase()] = key;
        return acc;
      },
      {} as Record<string, string>,
    );

    if (name.toLowerCase() === 'tabname') {
      const tabNameKey = lowerKeyMap['tabname'];
      return tabNameKey ? row[tabNameKey] : undefined;
    }

    if (
      name.toLowerCase() === 'fieldnumber' ||
      name.toLowerCase() === 'field#'
    ) {
      const fieldNumberKey = lowerKeyMap['fieldnumber'];
      return fieldNumberKey ? row[fieldNumberKey] : undefined;
    }

    if (name.toLowerCase() === 'longlabel') {
      const longLabelKey = lowerKeyMap['longlabel'];
      return longLabelKey ? row[longLabelKey] : undefined;
    }

    if (name.toLowerCase() === 'value') {
      const valueKey = lowerKeyMap['value'];
      return valueKey ? row[valueKey] : undefined;
    }

    if (
      name.toLowerCase() === 'validationdesc' ||
      name.toLowerCase() === 'validationcodedescription'
    ) {
      const validationKey = lowerKeyMap['validationdesc'];
      return validationKey ? row[validationKey] : undefined;
    }

    const actualKey = lowerKeyMap[name.toLowerCase()];
    return actualKey ? row[actualKey] : undefined;
  }
}
